var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0387 0.34375L10.6278 1.76127L13.898 5.01624L0.292969 5.02993L0.294982 7.02993L13.8627 7.01627L10.6476 10.2465L12.0651 11.6574L17.7087 5.98735L12.0387 0.34375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0387 0.34375L10.6278 1.76127L13.898 5.01624L0.292969 5.02993L0.294982 7.02993L13.8627 7.01627L10.6476 10.2465L12.0651 11.6574L17.7087 5.98735L12.0387 0.34375Z",
    fill: "url(#paint0_linear_812_1510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_812_1510",
    x1: 8.46772,
    y1: 0.34375,
    x2: 14.3049,
    y2: 8.56401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#390EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9244F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.a66530612a98618bae8929249ed77c49.svg";
export { ForwardRef as ReactComponent };